<script>

    import { toast } from 'bulma-toast'
    import { prepaidsStore, prepaidStore, modalStore, adminStore } from '../stores'

    import { isPermission } from '../$methods/permissions.methods'

    import PrepaidsService from '../$services/prepaids.service'
    import DateMethods from '../$methods/date.methods'

    import ButtonDelete from '../$components/button.delete.svelte'
    import ButtonModal from '../$components/button.modal.svelte'
    import InfoCard from '../$components/info.card.svelte'
    import InfoField from '../$components/info.field.svelte'

    let loading = false

    async function deletePrepaid() {

        loading = true
        const resp = await PrepaidsService.deletePrepaid($prepaidStore._id)
        loading = false

        if(!resp.success)
            return toast({message: resp.error.message, type: 'is-danger'})

        prepaidsStore.remove($prepaidStore._id)
        toast({message: 'Prepago eliminado', type: 'is-success'})

        modalStore.close()
    }

</script>

<InfoCard subtitle="Prepago">
    <div class="columns is-multiline is-mobile is-variable is-4 mb-0">
        <InfoField label="Estatus" icon="fas fa-info-circle" value={ ($prepaidStore.shipments.length < $prepaidStore.shipmentsTotal && DateMethods.isAfter($prepaidStore.expired)) ? 'Activo' : 'Expiró' } />
        <InfoField label="Proveedor" icon="fas fa-truck" value={ $prepaidStore.provider } bold />
        <InfoField label="Servicio" icon="fas fa-box" value={ $prepaidStore.service } />
        <InfoField label="Peso" icon="fas fa-weight" value="{ $prepaidStore.volumetricMin }kg a { $prepaidStore.volumetricMax }kg" />
        {#if $prepaidStore.admin?.name}
            <InfoField label="Admin" icon="fas fa-user-shield" value={ $prepaidStore.admin.name } />
            <InfoField label="Correo admin" icon="fas fa-envelope" value={ $prepaidStore.admin.email } />
        {/if}
        <InfoField label="Total" icon="fas fa-layer-group" value={ $prepaidStore.shipmentsTotal } />
        <InfoField label="Precio por guía" icon="fas fa-dollar-sign" value="${ $prepaidStore.shipmentPrice }" />
        <InfoField label="Usadas" icon="fas fa-check-circle" value={ $prepaidStore.shipments.length } />
        <InfoField label="Canceladas" icon="fas fa-times-circle" value={ $prepaidStore.canceled.length } />
        <InfoField label="Creación" icon="far fa-calendar-alt" value={ DateMethods.dateTimeLarge($prepaidStore.created) } />
        <InfoField label="Expira" icon="far fa-calendar-times" value={ DateMethods.dateTimeLarge($prepaidStore.expired) } />
    </div>
</InfoCard>

<div class="items-end">
    <div class="buttons">
        {#if isPermission($adminStore, 'UsersView.Prepaid.Delete')}
            <ButtonDelete on:confirm={deletePrepaid} { loading } />
        {/if}
        {#if isPermission($adminStore, 'UsersView.Prepaid.Update')}
            <ButtonModal modalId="prepaid_update_modal" icon="edit" text="Actualizar" />
        {/if}
    </div>
</div>
